import React from "react";

const GrainIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5155 0.471618C20.8968 -0.157206 19.1013 -0.157206 17.4826 0.471618C15.1157 1.39208 12.8227 2.49253 10.6239 3.76332C8.42486 5.03228 6.32621 6.46782 4.34641 8.05735C2.99202 9.14461 2.09385 10.6996 1.82882 12.4161C1.44765 14.8878 1.25 17.4207 1.25 20.0007C1.24897 22.5399 1.44248 25.0755 1.82882 27.5852C2.09354 29.3015 2.99128 30.8565 4.34524 31.9439C6.87939 33.9783 9.60689 35.7594 12.4886 37.2615C12.8851 37.4685 13.3168 37.0474 13.1451 36.6356C11.9298 33.7145 11.2592 30.5099 11.2592 27.1499C11.2592 16.3607 18.1709 7.18678 27.8083 3.81391C28.2001 3.67744 28.2565 3.1351 27.8907 2.9398C26.1283 2.001 24.3343 1.17866 22.5155 0.471618ZM34.9705 7.51971C35.1995 7.69732 35.427 7.87694 35.6529 8.05852C37.0068 9.14597 37.9046 10.701 38.1693 12.4173C38.5505 14.889 38.7481 17.4219 38.7481 20.0018C38.7481 22.5806 38.5505 25.1135 38.1693 27.5864C37.9043 29.3022 37.0066 30.8568 35.6529 31.9439C33.6727 33.5335 31.5737 34.9691 29.3742 36.238C27.1401 37.5285 24.8484 38.6226 22.5155 39.5285C21.0906 40.0819 19.5231 40.1502 18.0556 39.7226C17.5862 39.5579 17.1932 39.2214 16.9815 38.772C15.6097 35.8662 14.8439 32.6192 14.8439 29.1934C14.8439 18.1713 22.7813 9.00203 33.2517 7.0903C33.5523 7.03713 33.8607 7.04789 34.1569 7.12188C34.453 7.19586 34.7303 7.33142 34.9705 7.51971Z",
  fill: "#00B96C"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GrainIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;